import React, { useEffect } from 'react'
import Header from '../Header/Header'
import { Outlet } from 'react-router-dom'
import { useToggleClassName } from '../../hooks/useToggleClassName'

const MintLayout = () => {
	const bannerimgsize = '100%'

	useEffect(() => {
		document.body.classList.add('collectionpages')
	}, [])
	useToggleClassName()

	return (
		<>
			<Header />
			<section className='mycollectionSec mintSec'>
				<div className='container-fluid'>
					<Outlet />
				</div>
			</section>
		</>
	)
}

export default MintLayout
